import { render, staticRenderFns } from "./APTT.vue?vue&type=template&id=3cd82ffe&scoped=true"
import script from "./APTT.vue?vue&type=script&lang=js"
export * from "./APTT.vue?vue&type=script&lang=js"
import style0 from "./APTT.vue?vue&type=style&index=0&id=3cd82ffe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd82ffe",
  null
  
)

export default component.exports